/**
 * MetricoolTracker
 *
 * Renders the Metricool tracking pixel on every public page view.
 * Re-fires when the pathname changes so SPA navigation is tracked.
 */

import { BRAND_METRICOOL_HASH } from "@/lib/brandConfig";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function MetricoolTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!BRAND_METRICOOL_HASH) return;
    // Skip admin panel pages
    if (pathname.startsWith("/admin")) return;
    // Only fire on the main production domain — skip Vercel preview URLs
    const { hostname } = window.location;
    if (hostname.endsWith(".vercel.app") || hostname === "localhost" || hostname === "127.0.0.1") return;
    const img = new Image();
    img.src = `https://tracker.metricool.com/c3po.jpg?hash=${BRAND_METRICOOL_HASH}&_=${Date.now()}`;
  }, [pathname]);

  return null;
}
